// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".summary-field.integration-field {\n  align-items: flex-start !important;\n  white-space: nowrap;\n}\n.summary-field.integration-field label {\n  padding-top: 9px;\n}\n.summary-field.integration-field .value input {\n  text-align: right !important;\n  padding-right: 41px;\n}\n", ""]);
// Exports
module.exports = exports;
